import actions from './actions';

export default {
  namespaced: true,
  // state,
  actions,
  // getters,
  // mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/daf/index.js